module.exports = __webpack_public_path__ + "img/15.ff1b8844.jpg";